if (!customElements.get('leo-bundle-form')) {
  customElements.define(
    'leo-bundle-form',
    class LeoBundleForm extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-leo-bundle-add]');
        this.error = this.querySelector('.leo-bundle__error');
        this.errorText = this.querySelector('[data-leo-bundle-error]');
        this.defaultError = this.errorText ? this.errorText.textContent : '';
        if (!this.button || this.button.dataset.leoBound) return;
        this.button.dataset.leoBound = 'true';
        this.button.addEventListener('click', () => this.add());
      }

      setLoading(state) {
        this.button.classList.toggle('loading', state);
        this.button.setAttribute('aria-busy', state ? 'true' : 'false');
        const spinner = this.button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !state);
      }

      showError(message) {
        if (!this.error) return;
        if (this.errorText) this.errorText.textContent = message || this.defaultError;
        this.error.hidden = false;
      }

      async add() {
        if (this.button.disabled || this.button.classList.contains('loading')) return;
        const ids = (this.dataset.ids || '').split(',').filter(Boolean);
        if (!ids.length) return;

        const cart = document.querySelector('cart-drawer');
        const routes = window.routes || {};
        const addUrl = `${routes.cart_add_url || '/cart/add'}.js`;
        const body = { items: ids.map((id) => ({ id: Number(id), quantity: 1 })) };

        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }

        if (this.error) this.error.hidden = true;
        this.setLoading(true);

        try {
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await response.json();

          if (!response.ok || data.status) {
            this.showError(data.description || data.message);
            return;
          }

          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'leo-bundle', cartData: data });
          }

          if (!cart || !data.sections) {
            window.location = routes.cart_url || '/cart';
            return;
          }

          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          const firstItem = Array.isArray(data.items) && data.items.length ? data.items[0] : {};
          cart.renderContents({ id: firstItem.id, sections: data.sections });
        } catch (error) {
          console.error(error);
          this.showError();
        } finally {
          this.setLoading(false);
        }
      }
    }
  );
}
